import { Injectable } from '@angular/core';
import { DistributionListService } from 'src/api/services/distribution-list.service';
import { DistributionListItemService } from 'src/api/services/distribution-list-item.service';
import { BehaviorSubject, Observable } from "rxjs";
import { StrictHttpResponse } from 'src/api/strict-http-response';
import { DistributionList } from 'src/api/models/distribution-list';
import { DistributionListItem } from 'src/api/models/distribution-list-item';
import { CustomerDistribution,Customer } from 'src/api/models';
import { ToastrService } from 'ngx-toastr';


@Injectable()
export class DistributionTableService {

    public distributionLists: DistributionList[];
    public remoteData: Observable<DistributionList[]>;
    private _remoteData: BehaviorSubject<DistributionList[]>;
    public distributionListItems: DistributionListItem[];
    public remoteItemData: Observable<DistributionListItem[]>;
    private _remoteItemData: BehaviorSubject<DistributionListItem[]>;

    public loading: boolean = false;
    public loadingItems: boolean = false;
    public customerId: number;

    constructor(
      private readonly service: DistributionListService,
      private readonly itemService: DistributionListItemService,
      private readonly toasterService: ToastrService) {

      this._remoteData = new BehaviorSubject([]);
      this.remoteData = this._remoteData.asObservable();
      this.remoteData.subscribe(s => console.log(s));

      this._remoteItemData = new BehaviorSubject([]);
      this.remoteItemData = this._remoteItemData.asObservable();
      this.remoteItemData.subscribe(s => console.log(s));

    }

    validate(distribution: DistributionList){
      if(distribution.listName && distribution.fromName && distribution.fromEmail && distribution.fromSmsNumber)
      {
        return true;
      }
      return false;
    }

    get(customerId: number) {
      this.customerId = customerId;
      this.loading = true;
      this.service.DistributionListGetDistributionLists(customerId).subscribe(results => {
        this._remoteData.next(results);
        this.distributionLists = results;
        this.loading = false;
      }, err => {
        this.toasterService.error("Failed to Load Distribution Lists");
        this.loading = false;
      });
    }

    getItem(distributionListId: number) {
      this.loadingItems = true;
      this.itemService.DistributionListItemGetDistributionListItems(distributionListId).subscribe(results => {
        this._remoteItemData.next(results);
        this.distributionListItems = results;
        this.loadingItems = false;
      });
    }

    add(customerId: number,distribution: DistributionList){
      distribution.customer = {customerId:customerId} as Customer;
      return this.service.DistributionListCreateOrUpdate(distribution).subscribe(s => {
        this.get(this.customerId);
        this.toasterService.success("Distributions List Created");
      }, e => {
        this.toasterService.error("Distribution List Not Created");
      });
    }

    addItem(distributionListId: number, distribution: DistributionListItem) {
      this.loadingItems = true;
      distribution.distributionListId = distributionListId;
      return this.itemService.DistributionListItemCreateOrUpdate(distribution).subscribe(s => {
        this.getItem(distribution.distributionListId);
        this.toasterService.success("Address Added");
      }, e => {
        this.toasterService.error("Address Not Added");
      });
    }

    remove(distributionListId: number) {
      return this.service.DistributionListDelete(distributionListId).subscribe(r =>{
        this.get(this.customerId);
        this.toasterService.success("Distribution List Deleted");
      }, e => {
        this.toasterService.error("Distribution List Not Deleted");
      });
    }

    removeItem(distributionListItem: DistributionListItem) {
      this.loadingItems = true;
      return this.itemService.DistributionListItemDelete(distributionListItem.distributionListItemId).subscribe(r => {
        this.getItem(distributionListItem.distributionListId);
        this.toasterService.success("Address Deleted");
      }, e => {
        this.toasterService.error("Address Not Deleted");
      });
    }

    update(distribution: DistributionList){
      return this.service.DistributionListCreateOrUpdate(distribution).subscribe(d => {
        this.get(distribution.customer.customerId);
        this.toasterService.success("Distribution List Updated");
      }, e => {
        this.toasterService.error("Distribution List Not Updated");
      });
    }

    updateItem(distribution: DistributionListItem) {
      this.loadingItems = true;
      return this.itemService.DistributionListItemCreateOrUpdate(distribution).subscribe(s => {
        this.getItem(distribution.distributionListId);
        this.toasterService.success("Address Updated");
      }, e => {
        this.toasterService.error("Address Not Updated");
      });
    }


}
